import { CartItem } from '@/types/cart.types';

export function isStandaloneCartItem(item: CartItem): boolean {
  return !item.slot.id;
}
